import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Button from '../../components/auth/styled/Button';
import Input from '../../components/auth/styled/Input';
import ErrorList from '../../components/auth/styled/ErrorList';
import Logo from '../../components/auth/styled/Logo';

const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.25);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.15);
  padding: 40px 32px 32px 32px;
  min-width: 400px;
  max-width: 90vw;
  text-align: center;
`;

const Title = styled.h2`
  font-size: 25px;
  font-weight: 600;
  color: #59616a;
  margin-bottom: 16px;
`;

const SubTitle = styled.p`
  font-size: 15px;
  color: #969ba1;
  margin-bottom: 24px;
`;

const CenteredInput = styled(Input)`
  display: block;
  margin: 0 auto 24px auto;
  text-align: center;
  width: 240px;
`;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const LoginOtpForm = ({ otp, onChange, onSubmit, error, onClose }) => {
  const { t } = useTranslation();

  return (
    <ModalBackdrop>
      <ModalContent>
        <Logo />
        <Title>{t('Two-Factor Authentication')}</Title>
        <SubTitle>
          {t('An authentication code has been sent to your phone. Please enter the code below.')}
        </SubTitle>
        <ErrorList error={error} />
        <StyledForm onSubmit={onSubmit}>
          <CenteredInput
            name="otp"
            placeholder={t('Authentication Code')}
            value={otp}
            onChange={onChange}
            required
            autoFocus
            maxLength={6}
            autoComplete="one-time-code"
          />
          <Button type="submit" margin="16px 0 0 0" width="100%">
            {t('Verify').toUpperCase()}
          </Button>
          {onClose && (
            <Button
              type="button"
              margin="16px 0 0 0"
              width="100%"
              style={{ background: '#6c757d' }}
              onClick={onClose}
            >
              {t('Cancel')}
            </Button>
          )}
        </StyledForm>
      </ModalContent>
    </ModalBackdrop>
  );
};

export default LoginOtpForm;